<template>
    <li>
        <button type="button" @click="toggle"
            class="w-full text-gray-900 font-normal rounded-lg flex justify-between items-center py-2 px-4 hover:bg-gray-50 group"
            :class="{ 'bg-gray-50':show, 'bg-white':!show }">
            <div>
                <font-awesome-icon :icon="icon"
                    class="w-5 h-5 text-gray-500 group-hover:text-orange-700 transition duration-75" />
                <span class="ml-3 group-hover:text-orange-700 font-medium">{{ label }}</span>
            </div>

            <font-awesome-icon icon="fa-solid fa-chevron-down" class="h-4 group-hover:text-orange-700 transition-transform duration-300 transform"
                :class="{ 'rotate-180': show, 'rotate-0': !show }" />
        </button>

        <div v-show="show">
            <ul>
                <li v-for="(link, index) in links" :key="index"
                    class="w-full p-2 text-gray-500 hover:text-gray-900 font-normal rounded-lg flex justify-between items-center group">
                    <router-link :to="{ name: link.to }" class="w-full group-hover:text-orange-700 rounded-lg hover:bg-gray-100 cursor-pointer font-medium px-10 py-1">
                        {{ link.label }}
                    </router-link>
                </li>
            </ul>
        </div>
    </li>
</template>

<script>
    export default {
        props: {
            links: {
                type:       Object,
                required:   true
            },
            label: {
                type:       String,
                default:    'Name',
                required:   true
            },
            icon: {
                type:       String,
                default:    'fa-solid fa-bars',
                required:   true
            }
        },
        data() {
            return {
                show: false
            }
        },
        methods: {
            toggle() {
                this.show = !this.show
            },
            isCurrentRouteActive() {
                const link = this.links.filter(link => link.to == this.$router.currentRoute.value.name)
                this.show = link.length ? true : false
                return link.length ? true : false
            }
        },
        mounted() {
            this.isCurrentRouteActive()
        }
    }
</script>

<style scoped>
    .router-link-exact-active {
        --tw-bg-opacity: 1;
        background-color: rgb(243 244 246 / var(--tw-bg-opacity));
        color: rgb(185 28 28 / var(--tw-text-opacity));
    }
</style>